module.exports = __webpack_public_path__ + "static/media/permisos.ec461bf0.webp";